import { defineStore } from "pinia";

// This Store cannot use useLocalFetch because useLocalFetch use it for api headers
export const useFacilityStore = defineStore("facilities", () => {
  const _facilities = reactive(new Array<FacilityDto>());
  const currentPage = ref<number>(1);
  const currentPageSize = ref<number>();
  const totalPages = ref<number>(1);
  const searchPhrase = ref<string>("");
  const statusFilter = ref<string>("");
  const currentFacility = ref<FacilityDto>();

  const facilities = computed<FacilityDto[]>(() => {
    if (searchPhrase.value && statusFilter.value) {
      return _facilities.filter((f) => {
        return (
          f.name &&
          f.name.toLocaleUpperCase().indexOf(searchPhrase.value.toLocaleUpperCase()) > -1 &&
          f.setupStatus == statusFilter.value
        );
      });
    } else if (searchPhrase.value) {
      return _facilities.filter((f) => {
        return f.name && f.name.toLocaleUpperCase().indexOf(searchPhrase.value.toLocaleUpperCase()) > -1;
      });
    } else if (statusFilter.value) {
      return _facilities.filter((f) => {
        return f.setupStatus == statusFilter.value;
      });
    } else {
      return _facilities;
    }
  });

  const statuses = computed<FacilitySetupStatus[]>(() => $ck._.uniq(_facilities.map((f) => f.setupStatus)));

  const setFacilities = (facilities: FacilityDto[]) => {
    _facilities.splice(0, _facilities.length, ...facilities);
  };

  return {
    facilities,
    totalPages,
    currentPage,
    currentPageSize,
    searchPhrase,
    statusFilter,
    statuses,
    currentFacility,
    setFacilities,
  };
});

export type FacilityStore = ReturnType<typeof useFacilityStore>;
